@if (event){
    <div class="relative card border-slate-200 dark:border-slate-500 border bg-slate-100 dark:bg-slate-700 text-lrpTicketBlack dark:text-stone-300" >
        <div class="flex px-4 gap-5 lg:mr-40 w-full">
            @if (event.image) {
                <div class="min-w-20 min-h-20 max-h-20 max-w-20 bg-center bg-cover rounded-xl shadow-md shadow-lrpTicketBlack transition-transform ease-in-out duration-500" style="background-image: url('{{ event.image.url}}');">
                    @if (event.eventHost.img) {
                        <img [src]="event.eventHost.img.url" class="w-10 my-1 mx-1 mix-blend-multiply hover:w-16 hover:mt-3 hover:ms-2" [alt]="event.eventHost.name">
                    }
                </div>
            }
            @else {
                <div class="min-w-20 min-h-20 max-h-20 max-w-20 p-4 rounded-xl shadow-md shadow-lrpTicketBlack">
                    @if (event.eventHost.img) {
                        <img [src]="event.eventHost.img.url" class="mix-blend-multiply" [alt]="event.eventHost.name">
                    }
                </div>
            }
            <div class="w-full h-full">
                <div class="flex justify-between">
                    <h2 class="cursor-pointer" [routerLink]="'/events/' + event.eventLink">{{event.eventHost.eventSystem.name }} {{ event.eventHost.display ? ' - ' + event.eventHost.name + ' ' : '' }} | {{ event.name }}</h2>
                    @if (event.eventHost.eventSystem.img) {
                        <a [routerLink]="'/system/' + event.eventHost.eventSystem.systemRef"><img class="max-h-14 -mt-3" [src]="event.eventHost.eventSystem.img.url" alt=""></a>
                    }
                </div>
                <p class=" text-gray-400 -mt-3" i18n>
                    @if (event.eventStart == event.eventEnd) {
                        {{ event.eventStart | date:'shortDate' : 'en-GB'}}
                    }
                    @else if (event.eventStart != event.eventEnd) {
                        {{ event.eventStart | date:'shortDate' : 'en-GB'}} - {{ event.eventEnd | date:'shortDate' : 'en-GB'}}
                    }
                </p>
                <p class="text-md text-gray-400 -mt-1" i18n>
                    <a href="https://www.google.com/maps/search/?api=1&query={{ event.location }}">{{ event.location.split(',')[0] }}</a>
                </p>
            </div>
        </div>
        @if (adminMenu){
            <div class="mt-3 px-4 w-full">
                <hr class="my-2">
                <app-admin-event-menu [lrpEvent]="event" (showWizard)="wizard.set(true)"/>
            </div>
            @if (wizard()){
                <app-admin-event-wizard [eventRef]="event.eventID" [visible]="wizard" />
            }
        }
    </div>
}